import { setVideoSource } from '~/lib/videoFit'

const logger = console.scope('cameras')

/** Publish the acquired camera's pixel size. The fit itself is derived on read (`~/lib/videoFit`), never stored. */
export const updateVideoFitDimensions = () => {
	if (!window.camera_stream) {
		logger.warn('updateVideoFitDimensions', 'No camera stream')
		setVideoSource()
		return
	}
	const settings = window.camera_stream.getVideoTracks()[0].getSettings()
	if (!settings.width || !settings.height) logger.warn('updateVideoFitDimensions', settings)
	setVideoSource(settings.width, settings.height)
}

export default updateVideoFitDimensions
